import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { Panel, Loader } from "@culturehq/components";

import { GetState } from "app/hooks/useGet";
import { Trans } from "app/utils";

import Change from "./Change";

type EventStats = {
  stats: {
    rating: {
      average: number;
      change: number;
    };
  };
};

type EventRatingProps = {
  get: GetState<EventStats>;
};

const EventRatingContent: React.FC<EventRatingProps> = ({ get }) => {
  if (get.getting) {
    return <Loader loading />;
  }

  if (get.error) {
    throw get.error;
  }

  const { average, change } = get.got.stats.rating;
  const styles = buildStyles({
    pathColor: "#79b17d",
    textColor: "#646464",
    trailColor: "#d6d6d6",
    backgroundColor: "#3e98c7"
  });

  return (
    <div className="card_info dis_flex">
      <div className="circle_progress">
        <CircularProgressbar
          value={average}
          maxValue={5}
          text={average?.toFixed(2)}
          strokeWidth={4}
          styles={styles}
        />
        {Math.abs(change) >= 0.01 && (
          <Change change={change}>
            {change.toFixed(2)}
          </Change>
        )}
      </div>
    </div>
  );
};

const EventRating: React.FC<EventRatingProps> = ({ get }) => (
  <Panel>
    <Panel.Body className="card_holder">
      <div className="card_title">
        <h3>
          <Trans>Average Program Rating</Trans>
        </h3>
      </div>
      <EventRatingContent get={get} />
    </Panel.Body>
  </Panel>
);

export default EventRating;
